import {createSlice } from '@reduxjs/toolkit';
import { __ } from 'ramda';
import { initial } from './initial';

const set = key => (state,{payload}) => {state[key] = payload}

const uiSlice = createSlice({
  name: 'ui',
  initialState:initial,
  reducers: {
    set_selected: set("selected"),
    set_session: set("session"),
    set_decision: set("decision"),
    set_lang:(state,{payload}) => {state.lang = payload || (state.lang === "et" ? "en" : "et")},
    set_translations: set("ui_texts"),
    set_missing: set("missing"),
  },
})
export const {set_selected,set_lang,set_translations, set_missing,set_session,
  set_decision
} = uiSlice.actions

export default uiSlice.reducer

